module.exports = __webpack_public_path__ + "static/media/bliksem.f0a915db.png";